import { SessionScope } from "globals/enums";

export const isFaceDetectionEligible = (
  sessionType: SessionScope | undefined,
  organizationId: number,
  configuredOrganizationIds: number[]
) =>
  sessionType !== SessionScope.CandidateAuth && configuredOrganizationIds.includes(organizationId);
